import { render, staticRenderFns } from "./BasicDiff.vue?vue&type=template&id=3c44c559&scoped=true"
import script from "./BasicDiff.vue?vue&type=script&lang=js"
export * from "./BasicDiff.vue?vue&type=script&lang=js"
import style0 from "./BasicDiff.vue?vue&type=style&index=0&id=3c44c559&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c44c559",
  null
  
)

export default component.exports